import { toast } from "react-toastify";

const initState = {
  loading: false,
};

const authReducer = (state = initState, action) => {
  switch (action.type) {
    case "SIGN_IN":
      return {
        ...state,
        loading: false,
      };
    case "SIGN_IN_ERROR":
      if (action.payload.toString().includes("password")) {
        toast.error("Incorrect Email or Password");
      } else if (action.payload.toString().includes("no user")) {
        toast.error("Incorrect Email or Password");
      } else {
        toast.error("Couldn't Log you In");
      }
      console.log(action.payload.toString());
      return {
        ...state,
        loading: false,
      };
    case "SIGN_IN_ANON_ERROR":
      toast.error("Please Refresh the page");
      console.log(action.payload.toString());
      return state;
    case "SIGN_OUT":
      localStorage.removeItem("businessprofile");
      localStorage.removeItem("businessregion");
      window.location = "/";
      return {
        ...state,
        loading: false,
      };
    case "SIGN_OUT_ERROR":
      toast.error("Please Try Again");
      console.log(action.payload.toString());
      return {
        ...state,
        loading: false,
      };
      case "DELETE_ANON":
        return {
          ...state,
          loading: false,
        };
      case "DELETE_ANON_ERROR":
        console.log(action.payload.toString());
        return {
          ...state,
          loading: false,
        };
    case "SIGN_UP":
      toast.success("Successfully Registered");
      return {
        ...state,
        loading: false,
      };
    case "SIGN_UP_ERROR":
      toast.error("Couldn't Register your Business, Please try again later");
      console.log(action.payload.toString());
      return {
        ...state,
        loading: false,
      };
    case "RESET_PASSWORD":
      toast.success("Password Reset Email Sent");
      return {
        ...state,
        loading: false,
      };
    case "RESET_PASSWORD_ERROR":
      console.log(action.payload);
      toast.error(action.payload.toString());
      return {
        ...state,
        loading: false,
      };
    case "LOADING_AUTH":
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
};

export default authReducer;
